import { formatMoney } from "@shopify/theme-currency";

function resetChecked(button) {
  button.removeAttribute("checked");
}

function remakeImgSrc(currImgSrc, variantImgSrc) {
  const delimiter = "/";
  const start = 5;
  const pieces = currImgSrc.split(delimiter).slice(0, start);
  const linkPart1 = pieces.join(delimiter);
  const linkPart2 = currImgSrc.split("?")[1];

  return linkPart1 + "/" + variantImgSrc + "?" + linkPart2;
}

export const collectionCard = () => {
    const url = window.location.pathname;
    const isCollectionsPage = url.includes("/collections/");

    if (isCollectionsPage) {
     
        const productCards = document.querySelectorAll(
        ".card--product-with-add-to-cart",
        );

        for (let i = 0; i < productCards.length; i++) {

        // Handle variant scroller
        if (productCards[i].querySelector(".variants-scroller")) {
            const productCardMainImage =
            productCards[i].querySelectorAll("img")[0];
           
            // Handle variant display
            const productCardWidth = productCards[i].offsetWidth;
           
            const optionsWrap = productCards[i].querySelector(
            ".variants-container__options-wrap",
            );
            const optionsWrapWidth = optionsWrap.offsetWidth;

            if (optionsWrapWidth > productCardWidth) {
            const scrollControls =
                productCards[i].querySelectorAll(".variant-scroll");

            scrollControls.forEach((control) => {
                control.style.display = "block";
            });

            optionsWrap.style.padding = "0 28px";
            }

            const leftControl = productCards[i].querySelector(".scroll-left");
            const rightControl = productCards[i].querySelector(".scroll-right");

            leftControl.addEventListener("click", (e) => {
            e.currentTarget.parentNode.querySelector(
                ".variants-container",
            ).scrollLeft -= 150;
            });
            rightControl.addEventListener("click", (e) => {
            e.currentTarget.parentNode.querySelector(
                ".variants-container",
            ).scrollLeft += 150;
            });

            // Handle variant buttons
            const variantButtons = productCards[i].querySelectorAll(
            'input[type="radio"]',
            );

            const variantPrice =
            variantButtons[0].getAttribute("data-option-price");

            const productCardAddToCartBtn = productCards[i].querySelector(
                ".card__product-add-to-cart",
            );

            if (!productCardAddToCartBtn) {
                productCards[i].querySelector(".variants-scroller").classList.add('hidden')
                continue;
            }
            const productCardAddToCartBtnText = productCardAddToCartBtn.textContent;

            // Update Add to Cart button text
            if (!productCardAddToCartBtn.classList.contains('card__product-redirect-to-pdp-custom-label')) {
              productCardAddToCartBtn.textContent = productCardAddToCartBtnText + `\u2014 ${formatMoney(variantPrice)}`;
            }

            //variantButtons[0].setAttribute("checked", "true");
            //variantButtons[0].focus();

            for (let i = 0; i < variantButtons.length; i++) {
            variantButtons[i].addEventListener("click", (e) => {
              variantButtons.forEach((button) => {
              resetChecked(button);
              });
              e.currentTarget.setAttribute("checked", "true");

              const variantPrice =
              e.currentTarget.getAttribute("data-option-price");
              const variantImage =
              e.currentTarget.getAttribute("data-option-image");
              const variantId = e.currentTarget.getAttribute("data-option-variant-id")
              const variantSku = e.currentTarget.getAttribute('data-option-sku')
              const variantName = e.currentTarget.getAttribute('data-option-name')

              // Update Add to Cart button text
              if (!productCardAddToCartBtn.classList.contains('card__product-redirect-to-pdp-custom-label')) {
                productCardAddToCartBtn.textContent =
                  productCardAddToCartBtnText +
                  `\u2014 ${formatMoney(variantPrice)}`
              }

              productCardAddToCartBtn.setAttribute('data-product-sku', variantSku)
              productCardAddToCartBtn.setAttribute('data-product-variant-id', variantId)
              productCardAddToCartBtn.setAttribute('data-product-variant-name', variantName)
              productCardAddToCartBtn.setAttribute('data-product-variant-price', variantPrice)

              // Update image 
              const currentImgSrc = productCardMainImage.getAttribute("src");

              const newImgSrc = remakeImgSrc(currentImgSrc, variantImage);
              productCardMainImage.setAttribute("srcset", newImgSrc);
              productCardMainImage.setAttribute("src", newImgSrc);
              productCardMainImage.setAttribute("data-zoom", newImgSrc);
            });
            }
        }
        }
    }
}
